module.exports = __webpack_public_path__ + "img/kymalogo-only-blue.eab47dfc.svg";